var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mobile-header flex justify-between items-center"},[_c('div',{staticClass:"left",on:{"click":_vm.back}},[(_vm.from === 'result')?_c('back-result-svg'):_c('back-svg')],1),_vm._v(" "),_c('div',{staticClass:"center"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }